import type { AmplifyUser } from "@aws-amplify/ui";
import { getCognitoUserAttribute } from "helpers/utils";
import { useEffect } from "react";
import { getNotifications } from "store/notificationStore";
import { useAppDispatch } from "store/store";

type TParams = {
    user: AmplifyUser;
};

export function useNotification({ user }: TParams) {
    const dispatch = useAppDispatch();
    const userAttributes = getCognitoUserAttribute("custom:accountType", user);
    const baseURL =
        userAttributes === "beneficiary"
            ? import.meta.env.REACT_APP_API_BENEFICIAR_PORTAL_ENDPOINT
            : ["publisher", "admin"].includes(userAttributes)
              ? import.meta.env.REACT_APP_API_ENDPOINT
              : "";

    // Pollying notifications
    useEffect(() => {
        if (user && baseURL) {
            dispatch(getNotifications(baseURL));
            const interval = setInterval(() => {
                if (document.hasFocus() && !document.hidden) {
                    dispatch(getNotifications(baseURL));
                }
            }, 30000);

            return () => {
                clearInterval(interval);
            };
        }
    }, [dispatch, user, baseURL]);
}
